import request from './request'
// 获取员工列表
/**
 * @param {any} data
 */
export function manageList(data) {
  return request({
    url: '/dy/staff/list',
    method: 'post',
    data
  })
}
// 新增员工
/**
 * @param {any} data
 */
export function manageAdd(data) {
  return request({
    url: '/dy/staff/add',
    method: 'post',
    data
  })
}
// 编辑员工
/**
 * @param {any} data
 */
export function manageEdit(data) {
  return request({
    url: '/dy/staff/edit',
    method: 'post',
    data
  })
}
// 获取角色列表
/**
 * @param {any} data
 */
export function manageRoleList(data) {
  return request({
    url: '/dy/staff/role_list',
    method: 'post',
    data
  })
}
// 上传
/**
 * @param {any} data
 */
export function manageUpload(data) {
  return request({
    url: '/dy/staff/staff_upload',
    method: 'post',
    data
  })
}
// 修改当前角色状态
/**
 * @param {any} data
 */
export function changeStatus(data) {
  return request({
    url: '/dy/staff/status',
    method: 'post',
    data
  })
}